import React from 'react'

const CreditNotes = () => {
  return (
    <div>CreditNotes</div>
  )
}

export default CreditNotes